/**
* @ComponentFor Avensia.Shop.Features.Error.Pages.PageNotFoundViewModel
*/
import React from 'react';
import Main, { Section } from 'Shared/PageLayout';
import { translate } from 'Shared/translate';
export default (props) => (React.createElement(Main, { appearance: "narrow" },
    React.createElement(Section, null,
        React.createElement("h1", null, translate('/Errors/PageNotFoundHeader')),
        React.createElement("p", null, translate('/Errors/PageNotFoundText')))));
